<script setup lang="ts">
import { Order } from '@/@types/order'
import StatusBadge from '@/components/shared/base_orders/show/StatusBadge.vue'
import { Dialog, DialogOverlay } from '@/components/ui/dialog'
import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select'
import { ref } from 'vue'
import ConfirmCancel from './ConfirmCancel.vue'
import ConfirmPaid from './ConfirmPaid.vue'
import ConfirmReleased from './ConfirmReleased.vue'

defineProps<{ order: Order }>()

const statusToUpdate = ref('')
const dialogIsOpen = ref(false)
</script>

<template>
    <Dialog v-model:open="dialogIsOpen">
        <DialogOverlay class="z-60 bg-black/10" />
        <Select
            v-model="statusToUpdate"
            @update:model-value="dialogIsOpen = !dialogIsOpen"
            v-if="order.status != 'canceled' && order.status != 'refunded' && order.status != 'canceled_by_admin'"
        >
            <SelectTrigger
                class="!h-auto w-full border-none p-0 !text-slate-800 focus-visible:border-none focus-visible:ring-0 [&_svg]:!absolute [&_svg]:!ml-16 [&_svg]:md:!ml-22 [&_svg]:lg:!ml-16 [&_svg]:xl:!ml-34 [&_svg]:2xl:!ml-46"
            >
                <StatusBadge :status="order.status" />
            </SelectTrigger>
            <SelectContent class="z-[200]">
                <SelectItem v-for="status in order.available_statuses_for_update" :key="status" :value="status" class="cursor-pointer">
                    {{ $t(status) }}
                </SelectItem>
            </SelectContent>
        </Select>
        <StatusBadge :status="order.status" v-else />

        <ConfirmCancel :order="order" v-if="statusToUpdate == 'canceled'" />
        <ConfirmPaid :order="order" v-else-if="statusToUpdate == 'paid'" />
        <ConfirmReleased :order="order" v-else-if="statusToUpdate == 'released'" />
    </Dialog>
</template>
